export default function findFixedTo(table) {
  if (table && table.firstChild.firstChild.classList.contains('md-data-table__scroll-wrapper')) {
    return {
      x: table,
      y: table.firstChild.firstChild
    };
  }

  return table;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-md/es/DataTables/findFixedTo.js
// module id = 234
// module chunks = 0